import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "resetPassword",
  "use": "resetPassword-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"resetPassword\"><defs><style>#resetPassword .cls-1{fill:none}</style></defs><title>资源 10</title><g id=\"resetPassword_图层_2\" data-name=\"图层 2\"><g id=\"resetPassword_图层_1-2\" data-name=\"图层 1\"><path id=\"resetPassword_Rectangle_45_Copy_21\" data-name=\"Rectangle 45 Copy 21\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"resetPassword_key\"><path id=\"resetPassword_Shape\" d=\"M11 20.51a6.75 6.75 0 0 1-.57-8.91L1.75 2.94a.84.84 0 0 1 0-1.19.84.84 0 0 1 1.19 0l8.66 8.65a6.75 6.75 0 1 1-.6 10.11zm1.19-8.35a5 5 0 1 0 3.58-1.49 5.06 5.06 0 0 0-3.58 1.49zM7.06 5.83L8.84 4A.85.85 0 0 1 10 5.23L8.25 7zM4.8 3.57l1.79-1.79A.85.85 0 0 1 7.78 3L6 4.77z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/resetPassword.svg
// module id = aXOA
// module chunks = 6